<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout class="ma-0 pa-0 filter-area" justify-end>
        <div>
            <VDaterange
                    :presets="datePresets"
                    @input="dateRangeSelected"
                    v-model="dateRange"
            ></VDaterange>
        </div>
        <v-menu
                v-if="metricFilter || commentedStatusFilter || tagFilter"
                v-model="filterMenu"
                :close-on-content-click="false"
                offset-y
        >
            <template v-slot:activator="{ on }">
                <div class="filter-menu-button d-flex" v-on="on" v-tippy="{
                  placement: 'right',
                  arrow: true,
                  arrowTransform: 'scale(0.75)',
                  theme: 'lgrm-tooltip-tippy'
                }"
                     title="Filters">
                    <img :src="require('./img/filter.svg')"/>
                </div>
            </template>
            <v-card class="pa-4 filter-items">
                <div class="filter-header">Select filters</div>
                <label>Metrics</label>
                <v-select
                        class="lg-select"
                        style="margin-right: 0;margin-left: auto"
                        :items="metricTypes"
                        item-text="label"
                        item-value="id"
                        solo
                        v-model="selectedMetric"
                ></v-select>
                <label>Comments</label>
                <v-select
                        class="lg-select"
                        style="margin-right: 0;margin-left: auto"
                        :items="commentedStatuses"
                        item-text="label"
                        item-value="id"
                        solo
                        v-model="commentedStatus"
                ></v-select>
                <label>Tags</label>
                <v-select
                        class="lg-select"
                        style="margin-right: 0;margin-left: auto"
                        :items="$store.getters['campaign/tags']"
                        item-text="tag"
                        item-value="id"
                        no-data-text="No tags added"
                        solo
                        multiple
                        v-model="selectedTags"
                ></v-select>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed="" color="primaryLight7" round small @click="filterMenu = false">Cancel</v-btn>
                    <v-btn
                            color="accent"
                            depressed
                            round
                            dark
                            small
                            @click="
              filterChange()
              filterMenu = false
            "
                    >Apply
                    </v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-menu>
        <v-menu offset-y v-if="isTrendView" content-class="interval-filter-menu">
            <template v-slot:activator="{ on }">
                <div class="filter-menu-button d-flex" v-on="on">
                    <img v-tippy="{
                        placement: 'right',
                        arrow: true,
                        arrowTransform: 'scale(0.75)',
                        theme: 'lgrm-tooltip-tippy'
                        }"
                         title="Interval" :src="require('./img/interval.svg')"/>
                </div>
            </template>
            <v-list>
                <v-list-tile
                        v-for="(interval, index) in intervals"
                        :key="index"
                        @click="intervalChange(interval)"
                        class="interval-item"
                        :class="{'active': selectedInterval === interval.id}"
                >
                    <v-icon size="18" class="mr-2 check">check</v-icon>
                    <v-list-tile-title>{{ interval.label }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
        <v-menu offset-y content-class="attrs-filter-menu" 
        :close-on-content-click="false" v-model="attributeMenu">
            <template v-slot:activator="{ on }">
                <div class="filter-menu-button d-flex" v-on="on">
                    <img v-tippy="{
                            placement: 'right',
                            arrow: true,
                            arrowTransform: 'scale(0.75)',
                            theme: 'lgrm-tooltip-tippy'
                        }"
                        title="Attributes" :src="require('./img/attributes.svg')"/>
                </div>
            </template>
            <v-card class="pa-3 filter-items">
                <div class="filter-header" >Select attributes</div>
                <div class="attr-item " v-for="attr in attributes" :key="attr.id" @click=getAttributeValues(attr) >
                    <label>{{attr.label}}</label>
                    <v-select
                        v-if="attr.type !== 'DATE'"
                        class="lg-select"
                        style="margin-right: 0;margin-left: auto;height: 55px"
                        :items="attributeValues[attr.label]"
                        solo
                        multiple
                        v-model="selectedAttributes[attr.label]"
                        no-data-text=""
                        v-select-scroll-end
                        v-on:scrollend="getAttributeValues(attr)"
                    
                    ></v-select>
                    <v-layout v-if="attr.type == 'DATE'" class="date-attribute-filters"  col>
                        <v-flex>
                            <v-layout class="mb-1">
                                <v-checkbox
                                    v-model="attributeUiSettings[attr.label].dateFilter.on.enabled"
                                    class="date-attribute-filter-check"
                                    v-validate="'required'"
                                    label="On"
                                    data-vv-name="checkbox"
                                    type="checkbox"
                                    @change="attributeDateFilterTypeChange(attr, 'on')"
                                    required
                                    ></v-checkbox>
                                <!-- <input class="date-attribute-filter-text" type="text"/> -->
                                <v-menu
                                    :ref="attr.label + '_on'"
                                    v-model="attributeUiSettings[attr.label].dateFilter.on.menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="attributeUiSettings[attr.label].dateFilter.on.date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <input class="date-attribute-filter-text"
                                            v-model="attributeUiSettings[attr.label].dateFilter.on.formattedDate"
                                            readonly
                                            :disabled="!attributeUiSettings[attr.label].dateFilter.on.enabled"
                                            v-on="on" type="text"/>
                                    </template>
                                    <v-date-picker v-model="attributeUiSettings[attr.label].dateFilter.on.date" 
                                        @input="attributeDateFilterInput(attr, 'on', attributeUiSettings[attr.label].dateFilter.on.date)" 
                                        no-title scrollable>
                                    <v-spacer></v-spacer>
                                    </v-date-picker>
                                </v-menu>
                            </v-layout>
                            <v-layout class="mb-1">
                                <v-checkbox
                                v-model="attributeUiSettings[attr.label].dateFilter.before.enabled"
                                    class="date-attribute-filter-check"
                                    v-validate="'required'"
                                    label="Before"
                                    data-vv-name="checkbox"
                                    type="checkbox"
                                    required
                                    @change="attributeDateFilterTypeChange(attr, 'before')"
                                    ></v-checkbox>
                                <!-- <input class="date-attribute-filter-text" type="text"/> -->
                                <v-menu
                                    :ref="attr.label + '_before'"
                                    v-model="attributeUiSettings[attr.label].dateFilter.before.menu"
                                    :close-on-content-click="false"
                                    :nudge-right="10"
                                    :return-value.sync="attributeUiSettings[attr.label].dateFilter.before.date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <input class="date-attribute-filter-text"
                                        v-model="attributeUiSettings[attr.label].dateFilter.before.formattedDate"
                                        readonly
                                        :disabled="!attributeUiSettings[attr.label].dateFilter.before.enabled"
                                        v-on="on" type="text"/>
                                    </template>
                                    <v-date-picker v-model="attributeUiSettings[attr.label].dateFilter.before.date"
                                        @input="attributeDateFilterInput(attr, 'before', attributeUiSettings[attr.label].dateFilter.before.date)" 
                                        no-title scrollable>
                                    <v-spacer></v-spacer>
                                    </v-date-picker>
                                </v-menu>
                            </v-layout>
                            <v-layout class="mb-1">
                                <v-checkbox
                                v-model="attributeUiSettings[attr.label].dateFilter.after.enabled"
                                    class="date-attribute-filter-check"
                                    v-validate="'required'"
                                    label="After"
                                    data-vv-name="checkbox"
                                    type="checkbox"
                                    required
                                    @change="attributeDateFilterTypeChange(attr, 'after')"
                                    ></v-checkbox>
                                <!-- <input class="date-attribute-filter-text" type="text"/> -->
                                <v-menu
                                    :ref="attr.label + '_after'"
                                    v-model="attributeUiSettings[attr.label].dateFilter.after.menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="attributeUiSettings[attr.label].dateFilter.after.date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <input class="date-attribute-filter-text"
                                            v-model="attributeUiSettings[attr.label].dateFilter.after.formattedDate"
                                            readonly
                                            :disabled="!attributeUiSettings[attr.label].dateFilter.after.enabled"
                                            v-on="on" type="text"/>
                                    </template>
                                    <v-date-picker v-model="attributeUiSettings[attr.label].dateFilter.after.date"
                                        @input="attributeDateFilterInput(attr, 'after', attributeUiSettings[attr.label].dateFilter.after.date)" 
                                        no-title scrollable>
                                    <v-spacer></v-spacer>
                                    </v-date-picker>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed="" color="primaryLight7" round small @click="attributeMenu = false">Cancel</v-btn>
                    <v-btn
                        color="accent"
                        depressed
                        round
                        dark
                        small
                        @click="
                        attributeChange()
                        attributeMenu = false
                        "
                    >Apply
                    </v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-menu>
    </v-layout>
</template>

<script>
    import each from 'lodash/each'
    import find from 'lodash/find'
    import VDaterange from '@/components/vendors/VDaterange'
    import {filterDateQueryFormat} from '@/helpers/filter'
    import startOfWeek from 'date-fns/start_of_week'
    import startOfMonth from 'date-fns/start_of_month'
    import endOfMonth from 'date-fns/end_of_month'
    import startOfQuarter from 'date-fns/start_of_quarter'
    import startOfYear from 'date-fns/start_of_year'
    import subDays from 'date-fns/sub_days'
    import campaignApi from '@/api/campaign'
    export default {
        name: 'Filters',
        components: {VDaterange},
        props: {
            metricFilter: {
                type: Boolean,
                default: false
            },
            commentedStatusFilter: {
                type: Boolean,
                default: false
            },
            tagFilter: {
                type: Boolean,
                default: false
            },
            intervalFilter: {
                type: Boolean,
                default: false
            }
        },
        created() {
            const vm = this
            campaignApi.getAttributes(this.$router.currentRoute.params.campaignId).then(function (res) {
                vm.attributes = res.data.results.map(function(a){
                    a.page = 1
                    a.loading = true

                    vm.$set(vm.selectedAttributes, a.label, [])
                    vm.$set(vm.attributeValues, a.label, [])
                    if(a.type === 'DATE'){
                        let query = vm.$router.currentRoute.query['eml__' + a.label]
                        let onDate = ''
                        let beforeDate = ''
                        let afterDate = ''
                        let type = 'exact'
                        console.log(query)
                        if(query !== undefined && Object.keys(query).length > 0){
                            query = JSON.parse(query) 
                            if(query.on){
                                type = 'exact'
                                onDate = query.on.split('-').reverse().join('-')
                            }
                            if(query.before){
                                type = 'interval'
                                beforeDate = query.before.split('-').reverse().join('-')

                            }
                            if(query.after){
                                type = 'interval'
                                afterDate = query.after.split('-').reverse().join('-')
                            }
                        }
                        vm.$set(vm.attributeUiSettings, a.label, 
                            {dateFilter: {type: type, on: {date: onDate, menu: false, formattedDate: onDate.split('-').reverse().join('-'), 
                                                                enabled: onDate!==''}, 
                                                        after: {date: afterDate, menu: false, 
                                                                formattedDate: afterDate.split('-').reverse().join('-'), enabled: afterDate!==''}, 
                                                        before: {date:beforeDate, menu: false, formattedDate: beforeDate.split('-').reverse().join('-'),
                                                                enabled: beforeDate!==''}}})
                    }
                    return a
                })
            })
        },
        data: function () {
            // default dates are set in router with guard
            const dateRange = {}
            dateRange.from = this.$router.currentRoute.query.from.split('-').reverse().join('-')
            dateRange.to = this.$router.currentRoute.query.to.split('-').reverse().join('-')
            const last30Days = [
                filterDateQueryFormat(subDays(new Date(), 30)), // start date
                filterDateQueryFormat(subDays(new Date(), 0)) // end date
            ]
            const startOfCurrentWeek = startOfWeek(new Date())
            const thisWeek = [
                filterDateQueryFormat(startOfCurrentWeek), // start date
                filterDateQueryFormat(subDays(new Date(), 0)) // end date
            ]
            const lastWeek = [
                filterDateQueryFormat(startOfWeek(subDays(startOfCurrentWeek, 1))),
                filterDateQueryFormat(subDays(startOfCurrentWeek, 1))
            ]
            const startOfCurrentMonth = startOfMonth(new Date())
            const thisMonth = [
                filterDateQueryFormat(startOfCurrentMonth),
                filterDateQueryFormat(new Date())
            ]
            const lastMonthDate = subDays(startOfCurrentMonth, 1)
            const lastMonth = [
                filterDateQueryFormat(startOfMonth(lastMonthDate)),
                filterDateQueryFormat(endOfMonth(lastMonthDate))
            ]

            const thisQuarterStartDate = startOfQuarter(new Date())
            const thisQuarter = [
                filterDateQueryFormat(thisQuarterStartDate),
                filterDateQueryFormat(new Date())
            ]

            const lastQuarterEndDate = subDays(thisQuarterStartDate, 1)
            const lastQuarter = [
                filterDateQueryFormat(startOfQuarter(lastQuarterEndDate)),
                filterDateQueryFormat(lastQuarterEndDate)
            ]

            const thisYearStartDate = startOfYear(new Date())
            const thisYear = [
                filterDateQueryFormat(thisYearStartDate),
                filterDateQueryFormat(new Date())
            ]

            const lastYearEndDate = subDays(thisYearStartDate, 1)
            const lastYear = [
                filterDateQueryFormat(startOfYear(lastYearEndDate)),
                filterDateQueryFormat(lastYearEndDate)
            ]
            const metricTypes = [{id: 'ALL', label: 'All'}]
            each(this.$store.getters['campaign/enabledMetrics'], function (d) {
                let c = {}
                if (d === 'NPS') {
                    c = {id: 'NPS', label: 'NPS'}
                } else {
                    c = {id: d.replace('C', ''), label: d}
                }
                metricTypes.push(c)
            })
            return {
                date: new Date().toISOString().substr(0, 10),
                menu: false,
                dateRange,
                filterMenu: false,
                attributeMenu: false,
                metricTypes: metricTypes,
                selectedMetric: this.$router.currentRoute.query.m_type || 'ALL',
                commentedStatus: this.$router.currentRoute.query.text || 'ALL',
                commentedStatuses: [
                    {id: 'ALL', label: 'All'},
                    {id: 'present', label: 'With Comments'},
                    {id: 'absent', label: 'Without Comments'}
                ],
                tags: [],
                selectedTags: this.$router.currentRoute.query.tags || [],
                datePresets: [
                    {
                        label: 'Last 30 days',
                        range: last30Days
                    },
                    {
                        label: 'This week',
                        range: thisWeek
                    },
                    {
                        label: 'Last week',
                        range: lastWeek
                    },
                    {
                        label: 'This month',
                        range: thisMonth
                    },
                    {
                        label: 'Last month',
                        range: lastMonth
                    },
                    {
                        label: 'This quarter',
                        range: thisQuarter
                    },
                    {
                        label: 'Last quarter',
                        range: lastQuarter
                    },
                    {
                        label: 'This year',
                        range: thisYear
                    },
                    {
                        label: 'Last year',
                        range: lastYear
                    }
                ],
                intervals: [
                    {id: 'WEEKLY', label: 'Weekly'},
                    {id: 'MONTHLY', label: 'Monthly'},
                    {id: 'QUARTERLY', label: 'Quarterly'}
                ],
                selectedInterval: this.$router.currentRoute.query.interval,
                isTrendView: this.$router.currentRoute.fullPath.indexOf('trends') > -1,
                attributes: [],
                selectedAttributes: {},
                attributeValues: {},
                attributeUiSettings: {}
            }
        },
        watch: {
            $route: function () {
                this.isTrendView = this.$router.currentRoute.fullPath.indexOf('trends') > -1
                this.selectedInterval = this.$router.currentRoute.query.interval
            }
        },
        methods: {
            dateRangeSelected: function (range) {
                const q = {...this.$router.currentRoute.query}
                q.to = range.to.split('-').reverse().join('-')
                q.from = range.from.split('-').reverse().join('-')
                this.$router.push({query: q})
                this.$emit('change', range)
            },
            filterChange: function () {
                const q = {...this.$router.currentRoute.query}
                q.tags = this.selectedTags
                q.m_type = this.selectedMetric.replace('C', '')
                q.text = this.commentedStatus
                this.$router.push({query: q})
                this.$emit('change', q)
            },
            intervalChange: function (interval) {
                const q = {...this.$router.currentRoute.query}
                q.interval = interval.id
                this.$router.push({query: q})
                this.$emit('change', q)
            },
            attributeChange: function(){
                const vm = this
                const attrs = {}
                each(this.selectedAttributes, function(val, k){
                    attrs['eml__' + k] = val
                })
                each(this.attributeUiSettings, function(val, k){
                    const tmp = {}
                    console.log(vm.attributeUiSettings, 'attributeUiSettings')
                    if(vm.attributeUiSettings[k].dateFilter['on'].enabled && 
                        vm.attributeUiSettings[k].dateFilter['on'].formattedDate !== ''){
                        tmp.on = vm.attributeUiSettings[k].dateFilter['on'].formattedDate
                    }
                    if(vm.attributeUiSettings[k].dateFilter['after'].enabled&& 
                        vm.attributeUiSettings[k].dateFilter['after'].formattedDate !== ''){
                        tmp.after = vm.attributeUiSettings[k].dateFilter['after'].formattedDate
                    }
                    if(vm.attributeUiSettings[k].dateFilter['before'].enabled && 
                        vm.attributeUiSettings[k].dateFilter['before'].formattedDate !== ''){
                        tmp.before = vm.attributeUiSettings[k].dateFilter['before'].formattedDate
                    }
                    if(Object.keys(tmp).length > 0)
                        attrs['eml__' + k] = JSON.stringify(tmp)
                })
                const q = {...this.$router.currentRoute.query, ...attrs}
                this.$router.push({query: q})
                this.$emit('change', q)
                this.attributeMenu = false
            },
            getAttributeValues(attr){
                console.log(attr)
                const vm = this
                if(this.attributeValues[attr.label] && this.attributeValues[attr.label].length < attr.page * 20)
                    campaignApi.getAttributeValues(this.$router.currentRoute.params.campaignId, attr.id, attr.page).then(function(res){
                        vm.attributeValues[attr.label] = vm.attributeValues[attr.label].concat(res.data.results)
                        attr.page++
                    })
            },
            setSelectedAttributeFromQuery(attributes){

            },
            attributeDateFilterTypeChange(attr, type){
                console.log(attr, type)
                if(type=== 'on'){
                    if(this.attributeUiSettings[attr.label].dateFilter[type].enabled)
                    {
                        this.attributeUiSettings[attr.label].dateFilter['before'].enabled = false
                        this.attributeUiSettings[attr.label].dateFilter['after'].enabled = false
                    }
                }
                else if(type=== 'after' || type=== 'before'){
                    this.attributeUiSettings[attr.label].dateFilter['on'].enabled = false
                }
            },
            attributeDateFilterInput(attr, type, value){
                console.log(attr, type, value)
                const [year, month, day] = value.split('-')
                this.attributeUiSettings[attr.label].dateFilter[type].formattedDate = `${day}-${month}-${year}`
                this.attributeUiSettings[attr.label].dateFilter[type].menu = false
                // this.attributeUiSettings[attr.label].dateFilter[type].date = value
                console.log('dateis ', this.attributeUiSettings[attr.label].dateFilter[type].date)
            }
        }
    }
</script>

<style lang="stylus">
    .filter-area {
        margin-bottom 10px
        text-align right
        max-height 50px
        position sticky
        top: 0
        padding-top: 10px
        background #fff

        .filter-menu-button {
            height 40px
            width 40px
            border: 1px solid $color-primary-light-8;
            border-radius 5px
            margin-left 10px
            align-items center
            justify-content center
            cursor pointer

            img {
                max-width 25px
            }

        }

    }

    .filter-items {
        min-width 300px

        .filter-header {
            font-size 14px
            color: $color-primary-light-5
            margin-bottom 30px
        }
    }

    .interval-filter-menu {
        .v-list__tile__title {
            font-size: 14px
        }

        .theme--light.v-icon, .check {
            color: #fff

        }

        .active {
            font-weight: 500

            .check {
                color: $color-accent
            }
        }
    }

    .date-attribute-filters {
        color: $color-primary;
        border: 1px solid $color-primary-light-8;
        background: $color-primary-light-7;
        min-height 40px
        border-radius: 5px;
        font-weight 500
        box-shadow none
        padding: 5px
        .date-attribute-filter-check {
            height: 30px
            margin: 0px
        }
        .date-attribute-filter-text {
            border: 1px solid $color-primary-light-8;
            height: 30px
            background: #fff
            padding: 5px
            border-radius: 5px;
            &:disabled {
                cursor: not-allowed    
            }
        }
        .v-label.theme--light {
            color: $color-primary-light-1
            font-weight: 500
            font-size: 14px
        }
    }

    .attr-item {
        
    }
</style>
